import { render, staticRenderFns } from "./candidate-merge-dossier-form.vue?vue&type=template&id=7c88c1de&"
import script from "./candidate-merge-dossier-form.vue?vue&type=script&lang=js&"
export * from "./candidate-merge-dossier-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports